export default {
  title: '集装箱管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '箱型、ISO代码、描述',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addContainer: '新增集装箱',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enable: '启用',
    disable: '禁用',
    ediCodeSetting: 'EDI代码设置',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    containerType: '箱型',
    isoCode: 'ISO代码',
    description: '描述',
    ediCode: 'EDI代码',
    codeCount: '{count}个代码',
    notSet: '未设置',
    status: '状态',
    operation: '操作'
  },

  // 平台关联弹窗
  modal: {
    title: '新增集装箱类型',
    confirmText: '确认添加',
    searchPlaceholder: '搜索集装箱类型、ISO代码、描述',
    selected: '已选择 {count} 个集装箱类型',
    tableTitleContainerType: '箱型',
    tableTitleIsoCode: 'ISO代码',
    tableTitleDescription: '描述'
  },

  // 确认对话框
  confirm: {
    toggleStatus: '确定要{action}此集装箱吗？'
  },

  // EDI设置弹窗
  ediModal: {
    title: 'EDI代码设置',
    ediCodeList: 'EDI代码列表',
    platform: '平台',
    platformRequired: '请选择平台',
    platformPlaceholder: '选择平台',
    ediCode: 'EDI代码',
    ediCodeRequired: '请输入EDI代码',
    ediCodePlaceholder: '请输入EDI代码',
    addEdiCode: '添加EDI代码',
    deleteEdiCode: '删除',
    duplicateWarning: '平台重复',
    optional: '(非必填)',
    carrier: '承运人',
    carrierPlaceholder: '请选择承运人',
    duplicateRowsError: '第 {rows} 行存在重复的平台',
    duplicateRowsSaveError: '第 {rows} 行存在重复的平台，请修改后再保存'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的集装箱类型',
    selectToDisable: '请选择要禁用的集装箱类型',
    selectToAssociate: '请选择要添加的集装箱类型',
    loadError: '数据加载失败',
    platformLoadError: '平台数据加载失败',
    associateError: '添加失败',
    associateSuccess: '已添加 {count} 个集装箱类型',
    statusToggleError: '操作失败',
    statusToggleSuccess: '状态切换成功',
    batchEnableError: '批量操作失败',
    batchEnableSuccess: '已启用 {count} 个集装箱类型',
    batchDisableError: '批量操作失败',
    batchDisableSuccess: '已禁用 {count} 个集装箱类型',
    ediCodeSaveSuccess: 'EDI代码设置成功',
    ediCodeSaveError: 'EDI代码保存失败'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  }
}